// @flow

import React, { PureComponent } from 'react';
import C3Chart from 'react-c3js';
import 'c3/c3.css';

import Console from '../../../lib/debug';

type Props = {
    dataColumns: array,
    graphProps: object,
    x: string
};

export default class Graph extends PureComponent<Props> {
    render() {
        Console.render('Graph');
        const { dataColumns, x } = this.props;
        const {
            chartType,
            bindToElement,
            axis,
            legend,
            grid,
            bar,
            point,
            color
        } = this.props.graphProps;
        const data = {
            unloadBeforeLoad: true,
            x: x,
            columns: dataColumns,
            type: chartType
        };
        return (
            <C3Chart
                bindto={bindToElement}
                data={data}
                axis={axis}
                legend={legend}
                grid={grid}
                bar={bar}
                point={point}
                color={color}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/common/graph/Graph.js